{
  "borderStroke": {
    "auforumassurance": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "dealt": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "dougs": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "indy": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "jump": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "legalplace": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "legalstart": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "light": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "obat": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "phenix": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "previi": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "propulse": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "qonto": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "resco": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "revital": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "shine": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "sidecare": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    },
    "superindep": {
      "border-stroke-10": "0.5px",
      "border-stroke-20": "1px",
      "border-stroke-40": "4px",
      "border-stroke-30": "2px"
    }
  }
}
